import React from 'react'
import Link from 'umi/link';
import styles from '../index.less';

export default function Item(props) {

  const { bgc, title, data, url, borderRadius, color, fontWeight, marginBottom, borderBottom } = props;

  return (
    <>
      {url?
        <Link to={url}>
          <div style={{backgroundColor:bgc||'#EFEFEF',borderRadius:borderRadius||3, color:color||'#333333',fontWeight:fontWeight||500,marginBottom:marginBottom,borderBottom:borderBottom}} className={styles.DashboardItem}>
            <div className='item-title'>{title}</div>
            <div className='item-data'>{data}</div>
          </div>
      </Link>
      :
      <>
        <div style={{backgroundColor:bgc||'#EFEFEF',borderRadius:borderRadius||3, color:color||'#333333',fontWeight:fontWeight||500,marginBottom:marginBottom,borderBottom:borderBottom}} className={styles.DashboardItem}>
          <div className='item-title'>{title}</div>
          <div className='item-data'>{data}</div>
        </div>
      </>
    }
    </>
  )
}
